<template>
<div style="height: 100%;">
    <div id="main" v-show="!rotaAninhada">
        <container-loader
            v-if="isLoading && !$store.getters.isLoading"
        />
        <div class="page">
            <div class="tipos-servicos vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("situacao-cliente") }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        isVenda ? $t("vendas") :
                                        $t("agro")
                                    }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $t("situacao-cliente")
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            v-if="!usuarioIntegracao && permissao.create"
                            class="save-btn"
                            type="button"
                            tag="button"
                            @click="
                                $router.push({
                                    name: `${abrev}-situacao-new`,
                                })
                            "
                        >
                            {{ $t("adicionar") }}
                        </button>
                    </div>
                </div>

                <div class="search-and-filter">
                    <div class="search-bar">
                        <search-bar
                            :onSearch="debouncedOnSearch"
                            tooltipLabel="msg-campo-busca-tipo-recomendacao"
                        />
                    </div>

                    <div class="situacao-select">
                        <label v-text="$t('situacao')" />
                        <v-select
                            ref="situacaoInput"
                            class="is-100"
                            label="label"
                            :options="situacoes"
                            @input="onSituacaoChanged"
                            v-model="situacao"
                        >
                            <template slot="option" slot-scope="option">
                                {{ $t(option.label) }}
                            </template>
                            <template
                                slot="selected-option"
                                slot-scope="option"
                            >
                                {{ $t(option.label) }}
                            </template>
                            <template slot="no-options">{{
                                $t("sem-resultados")
                            }}</template>
                        </v-select>
                    </div>
                </div>

            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="situacoescliente"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                            'label-km': f.key == 'label',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'descricao'">
                            <router-link
                                :to="{
                                    name: `${abrev}-situacao-edit`,
                                    params: { id: props.row.id },
                                }"
                            >
                                <pre>{{ props.row[f.key] }}</pre>
                            </router-link>
                        </div>
                        <div v-else-if="f.key == 'cor'">
                            <div
                                class="color-block"
                                :style="`background-color: ${props.row.cor.startsWith('#') ? props.row.cor : ('#' + props.row.cor) }`"
                            ></div>
                        </div>
                        <div v-else-if="f.key == 'excluir'">
                            <b-button
                                v-if="permissao.delete && !usuarioIntegracao"
                                class="action-button"
                                :type="
                                    props.row['situacao'] == 1
                                        ? 'is-danger'
                                        : 'is-success'
                                "
                                :icon-right="
                                    props.row['situacao'] == 1
                                        ? 'delete'
                                        : 'check'
                                "
                                @click="promptChangeSituacao(props.row)"
                                v-tippy 
                                :title="$t(
                                    props.row['situacao'] == 1
                                        ? 'desativar'
                                        : 'reativar'
                                )"
                            />
                        </div>
                        <div v-else-if="f.key == 'situacao'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-if="props.row[f.key] == 1"
                                type="is-success"
                                size="is-medium"
                                >{{ $t("ativo") }}</b-tag
                            >
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-else
                                type="is-danger"
                                size="is-medium"
                                >{{ $t("inativo") }}</b-tag
                            >
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
            </div>
        </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import ContainerLoader from "@/components/content/loader/ContainerLoader";
import SituacaoService from "@/services/SituacaoService";
import HideInfo from "@/components/shared/HideInfo";

export default {
    beforeRouteUpdate(to, from, next) {
        if (
            to.name.includes(`${this.abrev}-situacao`) &&
            to.name != `${this.abrev}-situacao-list`
        ) {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados();
            next();
        }
    },
    components: {
        ContainerLoader,
        HideInfo,
    },
    data() {
        return {
            usuarioIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("SITUACAO"),
            situacoescliente: [],
            situacoes: [
                { id: 2, label: "todos" },
                { id: 1, label: "ativos" },
                { id: 0, label: "inativos" },
            ],
            situacao: { id: 2, label: "todos" },
            service: new SituacaoService(this.$http, this.$router),
            fields: [
                { key: "codigo", width: 55, sortable: true, sortFn: null },
                { key: "cor", width: 25, sortable: false, sortFn: null },
                { key: "descricao", width: null, sortable: true, sortFn: null },
                { key: "situacao", width: 70, sortable: true, sortFn: null },
                { key: "excluir", width: 20, sortable: false, sortFn: null },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            delete: null,
            queryFilter: "",
            column: "descricao",
            order: "asc",
            permissao: {},

            // @86308 - Rota dinâmica abreviando o contexto
            abrev: this.$route.meta.contexto.slice(0,3),
            isVenda: this.$route.meta.contexto == "vendas",
            isAgro: this.$route.meta.contexto == "agro",
        };
    },
    created() {
        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                "vendas",
                "clientes",
                "ven-situacao"
            );
        }else if (this.isAgro){
            this.abrev = this.$route.meta.contexto.slice(0,4);
            this.permissao = this.hasPermissionAccess( 
                'agro', 
                'clientes', 
                'agro-situacao'
            );
        }

        if (
            this.$route.name.includes(`${this.abrev}-situacao`) &&
            this.$route.name != `${this.abrev}-situacao-list`
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "situacao-cliente" },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    methods: {
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.situacao = val
                ? this.situacoes.filter((v) => v.id == val.id)[0]
                : this.situacoes[0];
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.situacoescliente = value;
                    this.isEmpty = this.situacoescliente.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-load");
                    console.error("Erro ao carregar os acertos.");
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        findAll(column, order, page, limit, situacao, ...params) {
            if(this.isVenda) {
                return this.service
                .findAllVendas(column, order, page, limit, situacao, ...params);
            }else {
                return this.service
                .findAllAgro(column, order, page, limit, situacao, ...params);
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map((m) => {
                return {
                    id: m.idsituacao,
                    codigo: m.idsituacaoerp,
                    descricao: m.descricao,
                    cor: m.cor,
                    situacao: m.situacao,
                    excluir: "excluir",
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? "msg-confirmacao-desativacao-n"
                        : "msg-confirmacao-reativacao-n", 
                    { n: row.descricao }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.situacao == 1
                    ? "msg-erro-ao-desativar-situacao"
                    : "msg-erro-ao-reativar-situacao";

            let tempSituacao = {
                idsituacao: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };

            this.isLoading = true;

            this.service
                .updateSituacao(tempSituacao)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.situacao == 1
                                ? "msg-sucesso-ao-reativar-situacao"
                                : "msg-sucesso-ao-desativar-situacao";
                        this.$root.showMessage("success", tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage(
                            "error",
                            "Erro ao atualizar status."
                        );
                    }
                })
                .catch((e) => {
                    console.error("Erro ao atualizar status.", e);
                    this.$root.showMessage("error", tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
    min-height: calc(100% - 50px);
    position: relative;

    .page {
        position: relative;
        padding-left: 0;


        .table-tag {
            width: 5rem !important;
        }

        .tipos-servicos .search-and-filter {
            display: flex;
            justify-content: space-between;
            margin: 10px 0;

            .search-bar {
                width: 80%;
                padding-right: 10px;
            }
            .situacao-select {
                width: 30%;
                div {
                    height: 40px;
                }
            }
            .filter-bar {
                width: 31%;
            }
            @media (max-width: 760px) {
                .search-bar {
                    padding-right: 0;
                }
                .situacao-select {
                    width: 100%;
                }
            }
        }
    }
}
</style>
